
import React from 'react';

export const AcademySection: React.FC = () => {
  return (
    <section id="academy" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Unsere Business Academy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ab Januar 2026 starten wir unsere Academy. Leider können wir es natürlich nicht schaffen, 
            alle Unternehmer gleichzeitig mit unserem Anspruch für Qualität aufzunehmen.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/34766969d45db3c2d347f6428b1f0dcd.jpg"
              alt="Business Academy"
              className="rounded-lg shadow-xl w-full h-96 object-cover object-top"
            />
          </div>
          
          <div>
            <div className="bg-red-100 border-l-4 border-red-500 p-6 mb-8">
              <div className="flex items-center mb-2">
                <i className="ri-alarm-warning-line text-red-500 text-xl mr-2"></i>
                <h3 className="text-lg font-semibold text-red-700">Begrenzte Verfügbarkeit</h3>
              </div>
              <p className="text-red-700">
                Da wir Sie wirklich jeden Tag, jede Woche direkt begleiten, sind aktuell nur noch 
                <span className="font-bold"> 40 freie Plätze</span> verfügbar.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-user-star-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Individuelle Begleitung</h4>
                  <p className="text-gray-600">
                    Unser Expertenteam begleitet Sie individuell bei der Lösung Ihrer wichtigsten Herausforderungen.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-time-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Flexibles Tempo</h4>
                  <p className="text-gray-600">
                    Sie bestimmen selbst Ihr Tempo, so dass wir uns darauf anpassen werden, 
                    wieviel Zeit Sie im Moment zur Verfügung haben.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Exklusiver Schutz</h4>
                  <p className="text-gray-600">
                    Wir beschränken die Teilnahme so, dass in jedem Postleitzahlgebiet pro Branche 
                    nur ein Teilnehmer geben wird.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
